<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
  
    <v-dialog persistent v-model="BlockingViolation" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-information-outline</v-icon>Blocking Value Violation</div>
            <p>Due to the Blocking Value set on the Client, the specified amount cannot be captured</p>
          </div>
        </v-card-text>
  
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-right mb-4">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="BlockingViolation = false">
              ok
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Unit Trust Subscription</v-toolbar-title>
      <v-spacer/>
      <span class="white--text caption font-weight-normal mr-3">Transacting Currency: {{Currency[0].CurrencyName}}</span>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>  </v-toolbar>
    </v-card>
  
  <!-- ********************************************************************************************CREATE**************************************************************************************************
  ***************************************************************************************************************************************************************************************************** -->
  
    <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="create">
      <v-card class="pt-3 mt-3" elevation="12">  
        <v-row class="ml-1 mr-1">
          <v-col class="pt-3 pb-0">
            <v-text-field
              light dense outlined
              color="#2A353D"
              v-model="Subscription.def.DealNumber"
              label="Transaction Ref"
              disabled
              placeholder="----"
            ></v-text-field>

            <v-text-field
              :value="currentSystemDate.DayDate"
              label="Transaction Date"
              append-icon="mdi-calendar-month"
              readonly placeholder="--/--/--"
              dense outlined color="#2A353D"
              readony
            ></v-text-field>

            <v-row class="mt-2">
              <v-col class="py-0" cols="4">
                <span class="grey--text subtitle-1 font-weight-normal">Transaction Mode:</span>
              </v-col>
              <v-col class="py-0">
                <v-radio-group v-model="Subscription.def.TransactionMode" row class="my-0" :mandatory="true">
                  <v-radio class="mr-8" label="Units" value=0></v-radio>
                  <v-radio class="ml-8" label="Cash" value=1></v-radio>
                </v-radio-group>                  
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-3 pb-0">
            <v-text-field
              outlined dense
              :value="Currency[0].CurrencyName"
              readonly
              placeholder="----"
              label="Currency"
            ></v-text-field>

            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="Subscription.def.ValueDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="Subscription.def.ValueDate"
                  label="Value Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense outlined color="#2A353D"
                  :error-messages="errors"
                  :rules="CreateDateRules"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker color="#2A353D" v-model="Subscription.def.ValueDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(Subscription.def.ValueDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>

            <v-select
              outlined dense @change="getClientDetails(Subscription.def.FundSponsorId); Subscription.Transactions = []"
              v-model="Subscription.def.FundSponsorId"
              :items="ClientGroups"
              item-text="CustodianName"
              item-value="CustodianID"
              placeholder="----"
              :rules="TextFieldRules"
              label="Client Group"
            ></v-select>
          </v-col>
        </v-row>

        <v-divider class="mx-4 my-0"></v-divider>
        <span class="grey--text subtitle-1 font-weight-normal ml-4 mt-0">Options to override auto allocation</span>

        <v-row class="ml-1 mr-1">
          <v-col class="py-0" cols="2">
            <v-checkbox hide-details class="mb-4" light v-model="Subscription.def.OverrideIndicator" label="Override"></v-checkbox>
          </v-col>
          <v-col class="py-0 mt-3">
            <v-select
              outlined dense @change="getBulkAccountValues()"
              v-model="Subscription.def.OverrideFundId"
              :items="FundNames"
              item-text="FundName"
              item-value="UnitTrustFundId"
              placeholder="----"
              :rules="TextFieldRules"
              label="Fund Name"
            ></v-select>
          </v-col>
          <v-col class="py-0 mt-3">
            <v-text-field
              light dense outlined
              color="#2A353D"
              v-model="Subscription.def.OverridePrice"
              label="Price" type="number"
              :rules="TextFieldRules"
              placeholder="----"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-data-table
        :headers="transaction_headers"
        :fixed-header="true"
        :items="Subscription.Transactions"
        disable-pagination
        hide-default-footer dense
        class="elevation-12 my-allocations-table mt-3"
      >
  
        <template v-slot:top >
          <v-toolbar dense flat>
            <v-toolbar-title class="grey--text caption font-weight-normal">Transactions</v-toolbar-title>
            <v-spacer/>
            <v-btn class="text-right" @click="NewTransaction(Subscription.Transactions)" x-small dark outlined fab color="#2A353D">
              <v-icon small >mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
  
        <template v-slot:item.AccountID="{ item }">
          <v-select
            @click="setActiveTransaction(item, index)"
            @change="getCurrentAccountValues(item); getCharges(item)"
            background-color="#ffffff00"
            v-model="item.AccountID"
            :items="Accounts"
            :menu-props="{ top: true, offsetY: true }"
            item-text="AccountName"
            item-value="AccountID"
            solo flat class="Account ma-0 pa-0 pt-5"
            placeholder="----" dense
            :rules="[
              v => !!v || 'field is required',
              v => Subscription.Transactions.filter(a => a.AccountID == item.AccountID).length < 2 || 'Account already selected'
            ]"
          ></v-select>
        </template>
  
        <template v-slot:item.CurrentHoldingUnits="{ item }">
          {{Number(item.CurrentHoldingUnits).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>
  
        <template v-slot:item.CurrentHoldingValue="{ item }">
          {{Number(item.CurrentHoldingValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>
  
        <template  v-slot:item.TransactionValue="{ item }">
          <v-text-field
            v-model="item.TransactionValue"
            :disabled="Subscription.def.TransactionMode == 0 ? true : false"
            @input="item.UnitsTransacted = item.TransactionValue / Subscription.def.OverridePrice; getCharges(item)"
            :rules="[
              // v => !!v || 'field is required',
              // v => v <= item.CurrentHoldingValue || 'Value Over-allocated'
            ]"
            single-line
            type="number"
          ></v-text-field>
        </template>

        <template v-slot:item.ChargeValue="{ item }">
          {{Number(item.ChargeValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>
  
        <template v-slot:item.NetAmount="{ item }">
          {{Number(item.NetAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>

        <template  v-slot:item.UnitsTransacted="{ item }">
          <v-text-field
            v-model="item.UnitsTransacted"
            label="Units Transacted"
            :disabled="Subscription.def.TransactionMode == 1 ? true : false"
            @input="item.TransactionValue = Subscription.def.OverridePrice * item.UnitsTransacted; getCharges(item)"
            :rules="[
              // v => !!v || 'field is required',
              // v => v <= item.CurrentHoldingUnits || 'Units Over-allocated'
            ]"
            single-line
            type="number"
          ></v-text-field>
        </template>

        <template  v-slot:item.Narration="{ item }">
          <v-text-field
            v-model="item.Narration"
            single-line
          ></v-text-field>
        </template>
  
        <template v-slot:item.action="{ item }">
          <v-icon small @click="removeTransaction(item, Subscription.Transactions)">mdi-close</v-icon>
        </template>
  
        <template v-slot:footer >
          <v-divider class="mt-0"/>
          <v-row class="ml-2 mr-2">
            <v-col class="pb-0 pt-7">
              <v-select
                outlined dense
                v-model="Subscription.def.DepositMethodID"
                :items="allDepositMethods.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="DepositMethodDescription"
                item-value="DepositMethodID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Subscription Method"
              ></v-select>
            </v-col>
            <v-col class="pb-0 pt-7">
              <v-text-field
                :value="Subscription.Transactions.map(t => Number(t.TransactionValue)).reduce((a, b) => a + b, 0)"
                label="Total Transaction Value"
                readonly placeholder="----"
                dense outlined color="#2A353D"
                :rules="[
                  // v => Subscription.Transactions.map(t => Number(t.TransactionValue)).reduce((a, b) => a + b, 0) <= Number(Subscription.OverridePrice) || 'Over allocated'
                ]"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-2 mr-2">
            <v-col class="pb-0" cols="2">

            </v-col>
            <v-col class="pb-0">

            </v-col>
            <v-col class="pb-0">

            </v-col>
            <v-col class="pb-0" cols="6">
              <div class="text-right mb-4">
                <v-btn class="white--text mr-4" small color="#2A353D" @click="closeCreate()">close</v-btn>
                <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  submit
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-form>
  
  <!-- ********************************************************************************************EDIT**************************************************************************************************
  ***************************************************************************************************************************************************************************************************** -->
  
    <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="edit" >
      <span class="d-flex flex-row mt-2">
        <span class="grey--text caption font-weight-normal">REFERENCE: <span class="subtitle-2">{{currentSubscription.DealNumber}}</span></span>
        <v-spacer/>
        <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSubscription.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        <span v-if="currentSubscription.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSubscription.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSubscription.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      </span>
      <v-card class="pt-3 mt-3" elevation="12">  
        <v-row class="ml-1 mr-1">
          <v-col class="pt-3 pb-0">
            <v-text-field
              light dense outlined
              color="#2A353D"
              v-model="currentSubscription.DealNumber"
              label="Transaction Ref"
              disabled
              placeholder="----"
            ></v-text-field>

            <v-text-field
              :value="currentSystemDate.DayDate"
              label="Transaction Date"
              append-icon="mdi-calendar-month"
              readonly placeholder="--/--/--"
              dense outlined color="#2A353D"
              readony
            ></v-text-field>

            <v-row class="mt-2">
              <v-col class="py-0" cols="4">
                <span class="grey--text subtitle-1 font-weight-normal">Transaction Mode:</span>
              </v-col>
              <v-col class="py-0">
                <v-radio-group v-model="currentSubscription.TransactionMode" row class="my-0" :mandatory="true" :readonly="view">
                  <v-radio class="mr-8" label="Units" value=0></v-radio>
                  <v-radio class="ml-8" label="Cash" value=1></v-radio>
                </v-radio-group>                  
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-3 pb-0">
            <v-text-field
              outlined dense
              :value="Currency[0].CurrencyName"
              readonly
              placeholder="----"
              label="Currency"
            ></v-text-field>

            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="currentSubscription.ValueDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="currentSubscription.ValueDate"
                  label="Value Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense outlined color="#2A353D"
                  :error-messages="errors"
                  :rules="CreateDateRules"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker :readonly="view" color="#2A353D" v-model="currentSubscription.ValueDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(currentSubscription.ValueDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>

            <v-select
              outlined dense @change="getClientDetails(currentSubscription.FundSponsorId); currentSubscription.transactions = []"
              v-model="currentSubscription.FundSponsorId"
              :items="ClientGroups"
              item-text="CustodianName"
              item-value="CustodianID"
              placeholder="----"
              :rules="TextFieldRules"
              label="Client Group"
              :readonly="view"
            ></v-select>
          </v-col>
        </v-row>

        <v-divider class="mx-4 my-0"></v-divider>
        <span class="grey--text subtitle-1 font-weight-normal ml-4 mt-0">Options to override auto allocation</span>

        <v-row class="ml-1 mr-1">
          <v-col class="py-0" cols="2">
            <v-checkbox hide-details :readonly="view" class="mb-4" light v-model="currentSubscription.OverrideIndicator" label="Override"></v-checkbox>
          </v-col>
          <v-col class="py-0 mt-3">
            <v-select
              outlined dense @change="getBulkAccountValues()"
              v-model="currentSubscription.OverrideFundId"
              :items="FundNames"
              item-text="FundName"
              item-value="UnitTrustFundId"
              placeholder="----"
              :rules="TextFieldRules"
              label="Fund Name" :readonly="view"
            ></v-select>
          </v-col>
          <v-col class="py-0 mt-3">
            <v-text-field
              light dense outlined
              color="#2A353D"
              v-model="currentSubscription.OverridePrice"
              label="Price" type="number"
              :rules="TextFieldRules"
              placeholder="----" :readonly="view"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-data-table
        :headers="transaction_headers"
        :fixed-header="true"
        :items="currentSubscription.transactions"
        disable-pagination
        hide-default-footer dense
        class="elevation-12 my-allocations-table mt-3"
      >
  
        <template v-slot:top >
          <v-toolbar dense flat>
            <v-toolbar-title class="grey--text caption font-weight-normal">Transactions</v-toolbar-title>
            <v-spacer/>
            <v-btn class="text-right" :disabled="view" @click="NewTransaction(currentSubscription.transactions)" x-small dark outlined fab color="#2A353D">
              <v-icon small >mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
  
        <template v-slot:item.AccountID="{ item }">
          <v-select
            @click="setActiveTransaction(item, index)"
            @change="getCurrentAccountValues(item); getCharges(item)"
            background-color="#ffffff00"
            v-model="item.AccountID"
            :items="Accounts"
            :menu-props="{ top: true, offsetY: true }"
            item-text="AccountName"
            item-value="AccountID"
            solo flat class="Account ma-0 pa-0 pt-5"
            placeholder="----" dense :readonly="view"
            :rules="[
              v => !!v || 'field is required',
              v => currentSubscription.transactions.filter(a => a.AccountID == item.AccountID).length < 2 || 'Account already selected'
            ]"
          ></v-select>
        </template>
  
        <template v-slot:item.CurrentHoldingUnits="{ item }">
          {{Number(item.CurrentHoldingUnits).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>
  
        <template v-slot:item.CurrentHoldingValue="{ item }">
          {{Number(item.CurrentHoldingValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>
  
        <template  v-slot:item.TransactionValue="{ item }">
          <v-text-field
            v-model="item.TransactionValue"
            :disabled="currentSubscription.TransactionMode == 0 ? true : false"
            @input="item.UnitsTransacted = item.TransactionValue / currentSubscription.OverridePrice; getCharges(item)"
            :rules="[
              // v => !!v || 'field is required',
              // v => v <= item.CurrentHoldingValue || 'Value Over-allocated'
            ]"
            single-line :readonly="view"
            type="number"
          ></v-text-field>
        </template>

        <template v-slot:item.ChargeValue="{ item }">
          {{Number(item.ChargeValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>
  
        <template v-slot:item.NetAmount="{ item }">
          {{Number(item.NetAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>

        <template  v-slot:item.UnitsTransacted="{ item }">
          <v-text-field
            v-model="item.UnitsTransacted"
            label="Units Transacted"
            :disabled="currentSubscription.TransactionMode == 1 ? true : false"
            @input="item.TransactionValue = currentSubscription.OverridePrice * item.UnitsTransacted; getCharges(item)"
            :rules="[
              // v => !!v || 'field is required',
              // v => v <= item.CurrentHoldingUnits || 'Units Over-allocated'
            ]"
            single-line :readonly="view"
            type="number"
          ></v-text-field>
        </template>

        <template  v-slot:item.Narration="{ item }">
          <v-text-field
            v-model="item.Narration"
            single-line :readonly="view"
          ></v-text-field>
        </template>
  
        <template v-slot:item.action="{ item }">
          <v-icon small @click="removeTransaction(item, currentSubscription.transactions)">mdi-close</v-icon>
        </template>
  
        <template v-slot:footer >
          <v-divider class="mt-0"/>
          <v-row class="ml-2 mr-2">
            <v-col class="pb-0 pt-7">
              <v-select
                outlined dense
                v-model="currentSubscription.DepositMethodID"
                :items="allDepositMethods.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="DepositMethodDescription"
                item-value="DepositMethodID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Subscription Method"
                :readonly="view"
              ></v-select>
            </v-col>
            <v-col class="pb-0 pt-7">
              <v-text-field
                :value="currentSubscription.transactions.map(t => Number(t.TransactionValue)).reduce((a, b) => a + b, 0)"
                label="Total Transaction Value"
                readonly placeholder="----"
                dense outlined color="#2A353D"
                :rules="[
                  // v => currentSubscription.transactions.map(t => Number(t.TransactionValue)).reduce((a, b) => a + b, 0) <= Number(Subscription.OverridePrice) || 'Over allocated'
                ]"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-2 mr-2">
            <v-col class="pb-0" cols="2">

            </v-col>
            <v-col class="pb-0">

            </v-col>
            <v-col class="pb-0">

            </v-col>
            <v-col class="pb-0" cols="6">
              <div class="text-right mb-4">
                <v-btn class="white--text" small color="#2A353D" @click="view = false, closeEdit()">close</v-btn>
                <v-btn class="white--text ml-4" v-if="!view" small color="#2A353D" :disabled="!valid || loading == true" @click="update()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  save
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-form>
  
  <!-- ********************************************************************************************TABLE**************************************************************************************************
  ***************************************************************************************************************************************************************************************************** -->
  
    <v-data-table
      disable-pagination
      hide-default-footer
      :height="520"
      :headers="headers"
      :fixed-header="true"
      :items="confirmedSubscriptions ? Subscriptions : Subscriptions.filter(a => a.CheckerID === 0)"
      :search="search" v-if="!create &&  !edit"
      sort-by="MakeDate"
      sort-desc
      class="elevation-12 mt-2"
      @current-items="getFiltered"
    >
  
      <template v-slot:top >
  
        <v-dialog persistent v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
            </v-card-title>
  
            <v-card-text>
              <v-select
                filled dense
                v-model="RejectionStatus"
                :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="RejectionReasonDescription"
                item-value="RejectionReasonID"
                label="Rejection Reasons"
              ></v-select>
            </v-card-text>
  
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-right mb-4">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('', false); close()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  ok
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
  
        <v-dialog persistent v-model="reverseDialog" max-width="500px">
          <v-form flat ref="form" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title>
                <span class="grey--text text-center">Deal Reversal</span>
              </v-card-title>
  
              <v-card-text>
                <span class="subtitle-1">{{reversal_description}}</span>
  
                <v-textarea
                  class="mt-3"
                  label="Reversal Reason"
                  v-model="ReversalReason"
                  outlined rows="6"
                  row-height="15"
                  :rules="TextFieldRules"
                  placeholder="----"
                ></v-textarea>
              </v-card-text>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseDialog = false">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="ReverseDeal()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    submit
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>          
          </v-form>
        </v-dialog>
  
        <v-container row>
          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>
  
          <v-spacer></v-spacer>
  
          <v-btn v-if="showCreateBtn == true" v-show="confirmedSubscriptions" @click="overlay = true; showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
            Create New<v-icon small>mdi-plus</v-icon>
          </v-btn>
          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" v-show="confirmedSubscriptions" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn @click="generatePDF(false)" text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentDataset"
                  type    = "xls"
                  name    = "Equity Purchases.xls">
    
                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </download-excel>
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentDataset"
                  type    = "csv"
                  name    = "Equity Purchases.csv">
    
                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </download-excel>
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="generatePDF(true)" v-show="confirmedSubscriptions" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
              CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); getClientGoups()">
  
            <v-list-item-title>
              {{ Currency.CurrencyName }}
            </v-list-item-title>
  
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn v-show="!confirmedSubscriptions" @click="confirmedSubscriptions = true" outlined small color="#2A353D" class="ml-2" v-on="on">
            ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
          </v-btn>
        </v-container>
      </template>
  
      <template v-slot:item.status="{ item }">
        <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
        <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
        <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
      </template>
  
      <template v-slot:item.actions="{ item }">
        <v-tooltip v-if="!confirmedSubscriptions && item.CheckerID == 0" top>
  
        </v-tooltip>
        <v-tooltip v-if="!confirmedSubscriptions && item.CheckerID == 0" top>
          <template v-slot:activator="{ on }">
          <v-btn
            small @click="updateStatus(item, true)"
            outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
            v-on="on"
            color="#2A353D" class="mr-3"
          >
            confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
          </v-btn>
          </template>
          <span>confirm</span>
        </v-tooltip>
        <v-tooltip v-if="!confirmedSubscriptions && item.CheckerID == 0" top>
          <template v-slot:activator="{ on }">
          <v-btn
            small @click="reject(); setActiveSubscription(item, index)"
            outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
            v-on="on"
            color="#2A353D" class="mr-3"
          >
            reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
          </v-btn>
          </template>
          <span>reject</span>
        </v-tooltip>
        <v-btn
          v-show="confirmedSubscriptions"
          small outlined v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
          @click="TotalValue = item.Quantity * item.UnitPrice; setActiveSubscription(item, index); showEdit(); closeCreate()"
          color="#2A353D" class="mr-3"
        >
          <span>edit</span>
        </v-btn>
        <v-btn
          small outlined
          @click="view = true; setActiveSubscription(item, index); showEdit(); closeCreate()"
          color="#2A353D" class="mr-3"
        >
          <span>view</span>
        </v-btn>
        <v-tooltip v-if="confirmedSubscriptions" top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              :disabled="showReverseBtn == true && item.CheckerID == 0 ? false : true"
              color="#2A353D" @click="setActiveSubscription(item, index); initReversal(item)"
            >
            mdi-backup-restore
            </v-icon>
          </template>
          <span>reverse</span>
        </v-tooltip>
      </template>
  
      <template v-slot:item.TransactionDate="{ item }">
        {{ item.TransactionDate | moment("DD MMM YYYY") }}
      </template> 
  
      <!-- <template v-slot:item.MakeDate="{ item }">
        {{ item.MakeDate | moment("DD MMMM YYYY") }}
      </template> -->
  
    </v-data-table>
  </v-container>
  </template>
  
  <script>
  import {mapGetters, mapActions} from "vuex";
  import UserService from '../services/user.service';
  import dealingService from '../services/dealing.service';
  // import transactionService from '../services/transaction.service';
  import administrationService from '../services/administration.service';
  import jsPDF from 'jspdf';
  import 'jspdf-autotable'
  
  export default {
    name: 'unit_trust_Subscription',
  
    data () {
      return {
        confirmedSubscriptions: true,
        edit: false,
        create:false,
        view: false,
        message: '',
        menu: false,
        dialog: false,
        reverseDialog: false,
        ReversalReason: '',
        reversal_description: '',
        overlay: false,
        permitted: null,
        permitted_dialog: true,
        loading: false,
        Taxable: false,
        search: '',
        valid: true,
        content: '',
        EquityQuantity: '',
        currentTransaction: null,
        transactionIndex: -1,
        currentSubscription: null,
        currentIndex: -1,
        CurrentDataset: [],
        headers: [
          {
            text: 'Deal Number',
            align: 'start',
            sortable: true,
            value: 'DealNumber'
          },
          { text: 'Transaction Date', value: 'TransactionDate', sortable: true },
          // { text: 'Value Date', value: 'ValueDate', sortable: true },
          // { text: 'Deposit Method', value: 'DepositMethodID', sortable: true },
          // { text: 'Date Created', value: 'MakeDate', sortable: true },
          { text: 'Status', value: 'status', sortable: false },
          { value: 'actions', sortable: false, align: 'end' },
        ],
        TextFieldRules: [
          v => !!v || 'field is required',
        ],
        CreateDateRules: [
          v => !!v || 'field is required',
          v => (v <= this.currentSystemDate.DayDate) || 'Date must not exceed Purchase Date'
        ],
        EditDateRules: [
          v => !!v || 'field is required',
          v => (v <= this.currentSubscription.defDate) || 'Date must not exceed Purchase Date'
        ],
        // AllocatedValueRules: [
        //   v => !!v || 'field is required',
        //   v => (!!v && v == Number(this.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
        // ],
        // AllocatedUnitsRules: [
        //   v => !!v || 'field is required',
        //   v => (!!v && v == Number(this.Subscription.def.Quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})) || 'should match Deal Quantity',
        // ],
        // EditAllocatedValueRules: [
        //   v => !!v || 'field is required',
        //   v => (!!v && v == Number(this.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
        // ],
        // EditAllocatedUnitsRules: [
        //   v => !!v || 'field is required',
        //   v => (!!v && v == Number(this.currentSubscription.Quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})) || 'should match Deal Quantity',
        // ],
        transaction_headers: [
          { text: 'Account Name', value: 'AccountID', sortable: false, width: 200 },
          { text: 'Current Units', value: 'CurrentHoldingUnits', sortable: false },
          { text: 'Current Value', value: 'CurrentHoldingValue', sortable: false },
          { text: 'Transaction Value', value: 'TransactionValue', sortable: false, },
          { text: 'Charge Value', value: 'ChargeValue', sortable: false },
          { text: 'Net Amount', value: 'NetAmount', sortable: false },
          { text: 'Units Transacted', value: 'UnitsTransacted', sortable: false },
          { text: 'Narration/Comment', value: 'Narration', sortable: false },
          { value: 'action', sortable: false }
        ],
        CurrencyId: 0,
        Accounts: [],
        ClientGroups: [],
        FundNames: [],
        TotalValue: 0,
        RejectionStatus: 0,
        Subscription: {
          def: {},
          Transactions: [],
        },
        errors: [],
        BlockingViolation: null,
        BNerrors: [],
      }
    },
  
    computed: {
      ...mapGetters([
        "allUnitTrustSubscriptions",
        "allApplicationDefaults",
        "allCurrencies",
        "allDepositMethods",
        "allRejectionReasons",
        "allDealers",
        "allUsers",
        "currentSystemDate",
        "allConfirmationSettings"
      ]),
  
      currentUser() {
        return this.$store.state.auth.user;
      },
      Subscriptions() {
        return this.allUnitTrustSubscriptions.filter(a => a.CurrencyId == this.CurrencyId);
      },
      Currency() {
        return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
      },
      DealerID() {
        return this.allDealers.filter(a => a.SystemUserID == this.currentUser.SecurityUserID).map(a => a.DealerID).toLocaleString();
      },
      showEditBtn() {
      for (let i = 0; i < this.currentUser.roles.length; i++) {
        if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowEdit)) == 1){
          return true
        }
      }
      return false;
      },
  
      showCreateBtn() {
      for (let i = 0; i < this.currentUser.roles.length; i++) {
        if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowCreate)) == 1){
          return true
        }
      }
      return false;
      },
  
      showConfirmBtn() {
      for (let i = 0; i < this.currentUser.roles.length; i++) {
        if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowConfirm)) == 1){
          return true
        }
      }
      return false;
      },
  
      showReverseBtn() {
      for (let i = 0; i < this.currentUser.roles.length; i++) {
        if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowReversal)) == 1){
          return true
        }
      }
      return false;
      },
  
      CheckerID(){
        if(this.allConfirmationSettings.filter(a => a.FunctionID == 323).map(a => a.Status)[0] == false){
          return this.currentUser.SecurityUserID
        } else {
          return 0
        }
      }
    },
  
    watch: {
      TotalValue: function(newValue) {
        this.getTaxes(newValue);
        this.getCharges(newValue)
      },
      'Subscription.def.BrokerNote': {
        handler: function(newValue) {
          if(newValue != null && newValue != ''){
            var data = {
              BrokerNote: newValue,
            };
  
            dealingService.checkBrokerNoteIsUnique(data)
            .then(response => {
              this.BNerrors = response.data[0].IsUnique ? [] : ['Broker Note already in use']
            })        
          }
        },
        deep: true
      },
      'currentSubscription.defID': {
        handler: function() {
          // this.currentSubscription.Quantity = Number(this.currentSubscription.Quantity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}))
  
          if (this.currentSubscription.InstrumentID >= 9000){
            this.ListedCounters = false
          }
  
          this.Taxable = !!this.currentSubscription.IsTaxable
          this.ConfirmationDate = this.currentSubscription.DealConfirmationDate
  
          // if(this.view != true){
          //   for (let i = 0; i < this.currentSubscription.Transactions.length; i++) {
          //     this.getCurrentAccountValues(this.currentSubscription.Transactions[i])
          //   }
          // }
  
          // for (let t = 0; t < this.currentSubscription.Transactions.length; t++) {
          //   this.currentSubscription.Transactions[t].Quantity = Number(this.currentSubscription.Transactions[t].Quantity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}))
          // }
        },
        deep: true
      }
    },
  
    created () {
      this.CurrencyId = this.allApplicationDefaults[0].CurrencyID;
      this.getClientGoups();
      this.getFundNames();
    },
  
    methods: {
      ...mapActions([
        "createUnitTrustDeal",
        "updateUnitTrustDeal",
        "updateUnitTrustDealStatus",
        "createReversal"
      ]),
  
       async createNew() {
        this.message = '';
  
        await this.validate()
  
        if (this.valid == true) {
          this.loading = true;
          this.Subscription.def.MakerID = this.currentUser.SecurityUserID,
          this.Subscription.def.CheckerID = this.CheckerID,
          this.Subscription.def.CurrencyId = this.CurrencyId,
          this.Subscription.def.LastUserID = this.currentUser.SecurityUserID,
          this.Subscription.def.TransactionCodeID = 56,
          this.Subscription.def.TransactionDate = this.currentSystemDate.DayDate,
      
          this.createUnitTrustDeal(this.Subscription)
          .then(response =>{
            this.$socket.client.emit('socketreq', {
              commit: 'newUnitTrustDeal',
              data: response.data
            });
            this.message = response.data.message
            this.loading = false;
            this.closeCreate()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          }) 
        }
      },
  
      async update() {
        this.message = '';
  
        await this.validate()
  
        if (this.valid == true) {
          this.loading = true;
          this.currentSubscription.CurrencyId = this.CurrencyId,
          this.currentSubscription.MakerID = this.currentUser.SecurityUserID,
          this.currentSubscription.LastUserID = this.currentUser.SecurityUserID,
          this.currentSubscription.CheckerID = 0,
          this.currentSubscription.CheckDate = null,
          this.currentSubscription.MakeDate = new Date(),
          this.currentSubscription.RejectionID = this.RejectionStatus,
      
          this.updateUnitTrustDeal(this.currentSubscription)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updUnitTrustDeal',
              data: this.currentSubscription
            });
            
            this.message = response.data.message
            this.loading = false;
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          })
        }
      },
  
      updateStatus(item, status) {
        this.message = '';
        this.loading = true;
  
        if(status == true){
          item.CheckerID = this.currentUser.SecurityUserID,
          item.LastUserID = this.currentUser.SecurityUserID,
          item.CheckDate = new Date(),
          item.updatedAt = new Date(),
          item.RejectionID = this.RejectionStatus,
          item.IsConfirmation = status,
  
          this.updateUnitTrustDealStatus(item)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updUnitTrustDeal',
              data: item
            });
            
            this.message = response.data.message
            this.loading = false;
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          }) 
        } else {
          this.currentSubscription.CheckerID = this.currentUser.SecurityUserID,
          this.currentSubscription.LastUserID = this.currentUser.SecurityUserID,
          this.currentSubscription.CheckDate = new Date(),
          this.currentSubscription.updatedAt = new Date(),
          this.currentSubscription.RejectionID = this.RejectionStatus,
          this.currentSubscription.IsConfirmation = status,
  
          this.updateUnitTrustDealStatus(this.currentSubscription)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updUnitTrustDeal',
              data: this.currentSubscription
            });
            
            this.message = response.data.message
            this.loading = false;
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          })        
        }
      },
  
      getClientGoups() {
        this.message = '';

        administrationService.getClientGroups()
        .then(response => {
          this.ClientGroups = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      },

      getFundNames() {
        this.message = '';

        administrationService.getFundNames()
        .then(response => {
          this.FundNames = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      },

      getClientDetails(GroupID) {
        this.message = '';
        let ClientGroupId = GroupID;
        let CurrencyID = this.Currency[0].CurrencyID;

        administrationService.getClientDetails(ClientGroupId, CurrencyID)
        .then(response => {
          this.Accounts = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      },
  
      async getCurrentAccountValues(item) {
        this.message = '';
        this.loading = true;

        if(this.create == true){
          let data ={
            UnitTrustFundId: this.Subscription.def.OverrideFundId,
            AccountId: item.AccountID,
            BalanceDate: this.currentSystemDate.DayDate            
          }

          let index = this.Subscription.Transactions.findIndex(i => i.AccountID == item.AccountID);
          console.log("Index: " + index)

          if (item.AccountID != null && this.Subscription.def.OverrideFundId != null) {
            let response = await administrationService.getClientUnitsBalance(data)
            this.Subscription.Transactions[index].CurrentHoldingUnits = response.data[0].UnitBalance;
            this.Subscription.Transactions[index].CurrentHoldingValue = response.data[0].ValueBalance;
          } else {
            this.Subscription.Transactions[index].CurrentHoldingUnits = 0;
            this.Subscription.Transactions[index].CurrentHoldingValue = 0;
          }
        } else if (this.edit == true) {
          let data ={
            UnitTrustFundId: this.currentSubscription.OverrideFundId,
            AccountId: item.AccountID,
            BalanceDate: this.currentSystemDate.DayDate            
          }

          let index = this.currentSubscription.transactions.findIndex(i => i.AccountID == item.AccountID);

          if (item.AccountID != null && this.currentSubscription.OverrideFundId != null) {
            let response = await administrationService.getClientUnitsBalance(data)
            this.currentSubscription.transactions[index].CurrentHoldingUnits = response.data[0].UnitBalance;
            this.currentSubscription.transactions[index].CurrentHoldingValue = response.data[0].ValueBalance;
          } else {
            this.currentSubscription.transactions[index].CurrentHoldingUnits = 0;
            this.currentSubscription.transactions[index].CurrentHoldingValue = 0;
          }
        }
        this.loading = false;
      },

      async getBulkAccountValues() {
        this.message = '';
        this.loading = true;

        if(this.create == true){
          for(let i = 0; i < this.Subscription.Transactions.length; i++){

            let data ={
              FunctionId: 905,
              UnitTrustFundId: this.Subscription.def.OverrideFundId,
              AccountId: this.Subscription.Transactions[i].AccountID,
              BalanceDate: this.currentSystemDate.DayDate,
              UnitsTransacted: this.Subscription.Transactions[i].UnitsTransacted,  
              TransactionValue: this.Subscription.Transactions[i].TransactionValue   
            }

            if (data.AccountId != null && data.UnitTrustFundId != null) {
              let response = await administrationService.getClientUnitsBalance(data)
              this.Subscription.Transactions[i].CurrentHoldingUnits = response.data[0].UnitBalance;
              this.Subscription.Transactions[i].CurrentHoldingValue = response.data[0].ValueBalance;

              let c_response = await administrationService.getUnitTrustCharge(data.FunctionId, data.AccountId, data.UnitTrustFundId, data.BalanceDate, data.UnitsTransacted, data.TransactionValue);
              this.Subscription.Transactions[i].ChargeValue = c_response.data[0][0].ChargeValue;
              this.Subscription.Transactions[i].NetAmount = Number(this.Subscription.Transactions[i].TransactionValue) - Number(c_response.data[0][0].ChargeValue);
            }            
          }
        } else if(this.edit == true){
          for(let i = 0; i < this.currentSubscription.transactions.length; i++){
            let data ={
              FunctionId: 905,
              UnitTrustFundId: this.currentSubscription.OverrideFundId,
              AccountId: this.currentSubscription.transactions[i].AccountID,
              BalanceDate: this.currentSystemDate.DayDate,
              UnitsTransacted: this.currentSubscription.transactions[i].UnitsTransacted,  
              TransactionValue: this.currentSubscription.transactions[i].TransactionValue   
            }

            if (data.AccountId != null && data.UnitTrustFundId != null) {
              let response = await administrationService.getClientUnitsBalance(data)
              this.currentSubscription.transactions[i].CurrentHoldingUnits = response.data[0].UnitBalance;
              this.currentSubscription.transactions[i].CurrentHoldingValue = response.data[0].ValueBalance;

              let c_response = await administrationService.getUnitTrustCharge(data.FunctionId, data.AccountId, data.UnitTrustFundId, data.BalanceDate, data.UnitsTransacted, data.TransactionValue);
              this.currentSubscription.transactions[i].ChargeValue = c_response.data[0][0].ChargeValue;
              this.currentSubscription.transactions[i].NetAmount = Number(this.currentSubscription.transactions[i].TransactionValue) - Number(c_response.data[0][0].ChargeValue);
            }            
          }
        }
        this.loading = false;
      },
  
      async getCharges(item) {
        this.loading = true;
        if(this.create == true){

          let FunctionId = 905;
          let AccountId = item.AccountID;
          let UnitTrustFundId = this.Subscription.def.OverrideFundId;
          let CurrentDate = this.currentSystemDate.DayDate;
          let UnitsTransacted = item.UnitsTransacted;
          let TransactionValue = item.TransactionValue

          let index = this.Subscription.Transactions.findIndex(i => i.AccountID == item.AccountID);
    
          if (AccountId != null) {
            let response = await administrationService.getUnitTrustCharge(FunctionId, AccountId, UnitTrustFundId, CurrentDate, UnitsTransacted, TransactionValue);
            this.Subscription.Transactions[index].ChargeValue = response.data[0][0].ChargeValue;
            this.Subscription.Transactions[index].NetAmount = Number(this.Subscription.Transactions[index].TransactionValue) - Number(response.data[0][0].ChargeValue);
          } else{
            this.Subscription.Transactions[index].ChargeValue = 0;
          }
        } else if(this.edit == true){
          let FunctionId = 905;
          let AccountId = item.AccountID;
          let UnitTrustFundId = this.currentSubscription.OverrideFundId;
          let CurrentDate = this.currentSystemDate.DayDate;
          let UnitsTransacted = item.UnitsTransacted;
          let TransactionValue = item.TransactionValue

          let index = this.currentSubscription.transactions.findIndex(i => i.AccountID == item.AccountID);
    
          if (AccountId != null) {
            let response = await administrationService.getUnitTrustCharge(FunctionId, AccountId, UnitTrustFundId, CurrentDate, UnitsTransacted, TransactionValue)
            this.currentSubscription.transactions[index].ChargeValue = response.data[0][0].ChargeValue;
            this.currentSubscription.transactions[index].NetAmount = Number(this.currentSubscription.transactions[index].TransactionValue) - Number(response.data[0][0].ChargeValue);
          } else{
            this.currentSubscription.transactions[index].ChargeValue = 0;
          }
        }
        this.loading = false;
      },
  
      generatePDF(IsPrint) {
        const addFooters = doc => {
          const pageCount = doc.internal.getNumberOfPages()
  
          for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i)
            // text is placed using x, y coordinates
            doc.setFontSize(10).text("Unit Trust Subscription", 0.5, 0.5);
            // create a line under heading 
            doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
            doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
            doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
              align: 'center'
            })
          }
        }
  
        let doc = new jsPDF({
          orientation: "potrait",
          unit: "in",
          format: "letter"
        });
  
        doc.setFont('helvetica');
        doc.setFontSize(5);
        doc.autoTable({
          body: this.CurrentDataset,
          margin: { left: 0.5, top: 0.6 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          theme: 'plain'
        });
        addFooters(doc);
        if(IsPrint == true){
          doc.output('dataurlnewwindow');
        } else{
          doc.save('Unit Trust Subscription.pdf')
        }
      },
  
      mapCurrency(currency) {
        return this.CurrencyId = currency.CurrencyID
      },
  
      allowedDates: val => val <= new Date().toISOString().split('T')[0],
  
      getCustodianName(id) {
        return this.DealCustodians.filter(a => a.CustodianID === id).map(a => a.CustodianName).toLocaleString()
      },
  
      getNetAmount(item) {
        item.NetAmount = item.TransactionValue - item.ChargeValue
        return item.NetAmount
      },
  
      getNetConsideration(item) {
        item.InstrumentValue = this.TotalValue + this.getTotalCharges() + this.getTotalVAT()
        return item.InstrumentValue
      },
  
      getAllocatedValue(item) {
        return item.map(i => Number(i.TransactionValue)).reduce((a, b) => a + b, 0);
      },
  
      getAllocatedUnits(item) {
        return item.map(i => Number(i.Quantity)).reduce((a, b) => a + b, 0);
      },
  
      NewTransaction(item) {
        item.push(
          {
            AccountID: null,
            CurrentHoldingUnits: 0,
            CurrentHoldingValue: 0,
            TransactionValue: 0,
            ChargeValue: 0,
            NetAmount: 0,
            UnitsTransacted: 0,
            Narration: ''
          }
        )
      },
  
      removeTransaction(item, parent) {
        const index = parent.findIndex(p => p.AccountID === item.AccountID);
        parent.splice(index, 1)
      },
  
      getFiltered(current){
        this.CurrentDataset = current;
      },
  
      unconfirmed() {
        this.confirmedSubscriptions = false
      },
  
      showEdit () {
        this.edit = true
      },
  
      closeEdit() {
        this.currentSubscription = null,
        this.edit = false
      },
  
      showCreate () {
        this.create = true;
      },
  
      closeCreate() {
        this.Subscription.Transactions = [],
        this.Subscription.def = {},
        this.create = false
      },
  
      reject () {
        this.dialog = true
      },
  
      close () {
        this.dialog = false
        this.RejectionStatus = 0
      },
  
      showMessage(){
        if(this.message){
          return true
        } else {
          return false
        }
      },
  
      validate () {
        this.$refs.form.validate()
        return this.valid
      },
  
      reset () {
        this.$refs.form.reset()
      },
  
      async EditTransaction (item) {
        if(this.view != true){
          for (let i = 0; i < item.transactions.length; i++) {
            await this.getCurrentAccountValues(item.transactions[i])
          }
          return item
        } else {
          return item
        }
      },
  
      async setActiveSubscription (item, index) {
        const subscription = await this.EditTransaction(item)
        this.getClientDetails(subscription.FundSponsorId)
  
        this.currentSubscription = subscription
        this.currentIndex = index
  
        // this.getBalances(this.currentSubscription.CustodialID)
        // this.getAccounts(this.currentSubscription.CustodialID)
        // this.retrieveSettlementDetails(this.currentSubscription.defDate)
      },
  
      async setActiveTransaction (item, index) {
        this.currentTransaction = item
        this.transactionIndex = index
      },
    },
  
    mounted () {
      UserService.isUnitTrust().then(
        () => {
          this.permitted = true;
          this.message = '';
        },
        error => {
          this.permitted = false;
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
      this.$root.$on("unconfirmedUnitTrustSubscriptions", () => {
        this.unconfirmed();
      });
    }
  }
  </script>
  
  <style scoped>
  .list {
    text-align: left;
    max-width: 750px;
    margin: auto;
  }
  
  .edit {
    background-color: #DBEFFA;
  }

  .section {
    background-color: rgb(242, 242, 242);
  }
  
  .v-btn {
    outline: none
  }
  
  /* .v-select__selections input {
    display: none;
  } */
  
  .Account {
    width: 200px;
  }
  
  .my-allocations-table{
    table-layout : fixed;
  }
  
  .table-text-field{
    width: 170px;
  }
  
  .headline {
    color:white
  }
  </style>
  